<template>
    <div class="card mt-1">
        <div class="card-body">
            <div class=" d-flex justify-content-between align-items-center">
                <div>
                    <button class="btn" @click="goToPrevious" :disabled="isFirstItem">
                        <img class="arrow-icon" src="@/assets/images/icon/prev.png" />
                    </button>
                    <button class="btn" @click="goToNext" :disabled="isLastItem">
                        <img class="arrow-icon" src="@/assets/images/icon/next.png" />
                    </button>
                </div>
                <div>
                    <button class="btn" @click="$emit('close')">
                        <img class="close-btn" src="@/assets/images/icon/close.png" />
                    </button>
                </div>
            </div>
            <div class=" d-flex justify-content-between align-items-center p-2 mt-4">
                <div class="transaction-title">Transaction details</div>
            </div>
            <div class="p-2" v-if="['Fee', 'Chargeback', 'Refund'].includes(currentTransaction.type)">
                <div class="col-item d-flex justify-content-between align-items-center">
                    <div class="col-title">Date</div> 
                    <div class="col-value">
                        {{ formatDate(currentTransaction.datetime) }}
                    </div>
                </div>
                <div class="col-item d-flex justify-content-between align-items-center">
                    <div class="col-title">Time</div> 
                    <div class="col-value">
                        {{ formatTime(currentTransaction.datetime) }}
                    </div>
                </div>
                <div class="col-line"></div>
                <div class="col-item d-flex justify-content-between align-items-center">
                    <div class="col-title">Transaction type</div> 
                    <div class="col-value" :class="currentTransaction.type == 'Refund' ? 'text-refund':'text-red'">
                        {{ currentTransaction.type }}
                    </div>
                </div>
                <div class="col-item d-flex justify-content-between align-items-center">
                    <div class="col-title">Description:</div> 
                    <div class="col-value">
                        {{ currentTransaction.description }}
                    </div>
                </div>
                <div class="col-line"></div>
                <div class="col-item d-flex justify-content-between align-items-center">
                    <div class="col-amount">Amount</div> 
                    <div class="col-pay">
                        {{ formatCurrency(currentTransaction.we_pay_you) }}
                    </div>
                </div>
                <div class="col-line"></div>
                <div class="col-item d-flex justify-content-between align-items-center">
                    <div class="col-title">Settlement Reference</div> 
                    <div class="col-value">
                        {{ currentTransaction.settlement_ref }}
                    </div>
                </div>
            </div>
            <div  v-else class="p-2">
                <div class="col-item d-flex justify-content-between align-items-center">
                    <div class="col-title">Date</div> 
                    <div class="col-value">
                        {{ formatDate(currentTransaction.datetime) }}
                    </div>
                </div>
                <div class="col-item d-flex justify-content-between align-items-center">
                    <div class="col-title">Time</div> 
                    <div class="col-value">
                        {{ formatTime(currentTransaction.datetime) }}
                    </div>
                </div>
                <div class="col-line"></div>
                <div class="col-item d-flex justify-content-between align-items-center">
                    <div class="col-title">Transaction reference</div> 
                    <div class="col-value">
                        {{ currentTransaction.transaction_ref }}
                    </div>
                </div>
                <div class="col-item d-flex justify-content-between align-items-center">
                    <div class="col-title">Transaction type</div> 
                    <div class="col-value">
                        {{ currentTransaction.type }}
                    </div>
                </div>
                <div class="col-item d-flex justify-content-between align-items-center">
                    <div class="col-title">Terminal</div> 
                    <div class="col-value">
                        {{ currentTransaction.terminal }}
                    </div>
                </div>
                <div class="col-item d-flex justify-content-between align-items-center">
                    <div class="col-title">Card type</div> 
                    <div v-if="formatToLowerCase(currentTransaction.card_type) === 'eftpos'">
                        <img class="payment-icon" src="@/assets/images/admin/transactions/eftpos.png" alt="Eftpos" />
                    </div>
                    <div v-if="formatToLowerCase(currentTransaction.card_type) === 'visa'">
                        <img class="payment-icon" src="@/assets/images/admin/transactions/visa.png" alt="Visa" />
                    </div>
                    <div v-if="formatToLowerCase(currentTransaction.card_type) === 'mastercard'">
                        <img class="payment-icon" src="@/assets/images/admin/transactions/mastercard.png" alt="Mastercard" />
                    </div>
                    <div v-if="formatToLowerCase(currentTransaction.card_type) === 'american express'">
                        <img class="payment-icon" src="@/assets/images/admin/transactions/amex.png" alt="Amex" />
                    </div>
                </div>
                <div class="col-item d-flex justify-content-between align-items-center">
                    <div class="col-title">Card last 4 digits</div> 
                    <div class="col-value">
                        {{ currentTransaction.card_last_4_digits }}
                    </div>
                </div>
                <div class="col-item d-flex justify-content-between align-items-center">
                    <div class="col-title">Status</div> 
                    <div class="col-value" :class="currentTransaction.transaction_status == 'Approved' ? 'text-green':''">
                        {{ currentTransaction.transaction_status }}
                    </div>
                </div>
                <div class="col-line"></div>
                <div class="col-item d-flex justify-content-between align-items-center">
                    <div class="col-title">Face value</div> 
                    <div class="col-value">
                        {{ formatCurrency(currentTransaction.face_value) }}
                    </div>
                </div>
                <div class="col-item d-flex justify-content-between align-items-center">
                    <div class="col-title">Commission</div> 
                    <div class="col-value">
                        {{ formatCurrency(currentTransaction.commission) }}
                    </div>
                </div>
                <div class="pay-line"></div>
                <div class="col-item d-flex justify-content-between align-items-center">
                    <div class="col-amount">We pay you</div> 
                    <div class="col-pay">
                        {{ formatCurrency(currentTransaction.we_pay_you) }}
                    </div>
                </div>
                <div class="col-line"></div>
                <div class="col-item d-flex justify-content-between align-items-center">
                    <div class="col-title">Payment status</div> 
                    <div class="col-value" :class="currentTransaction.payment_status == 'Settled' ? 'text-green':''">
                        {{ currentTransaction.payment_status }}
                    </div>
                </div>
                <div class="col-item d-flex justify-content-between align-items-center">
                    <div class="col-title">Settlement Reference</div> 
                    <div class="col-value">
                        {{ currentTransaction.settlement_ref }}
                    </div>
                </div>

            </div>
        </div>
    </div>

</template>

<script setup>
import { computed, reactive, watch, defineProps } from 'vue';
import { useTransactionStore } from '@/store/driver/transaction';
import { onBeforeRouteLeave } from 'vue-router';  


const props = defineProps({
  initialIndex: Number
});

const transactionStore = useTransactionStore();

// 將 paginatedData 中的所有交易提取為一維陣列
const allTransactions = computed(() => 
  Object.values(transactionStore.paginatedData).flat()
);

// 使用 reactive 追蹤當前索引
const state = reactive({
  currentIndex: props.initialIndex
});



// 取得當前的交易資料
const currentTransaction = computed(() => allTransactions.value[state.currentIndex]);

// 判斷是否為第一筆或最後一筆交易
const isFirstItem = computed(() => state.currentIndex === 0);
const isLastItem = computed(() => state.currentIndex === allTransactions.value.length - 1);

// 前往上一筆交易
const goToPrevious = () => {
  if (!isFirstItem.value) {
    state.currentIndex--;
  }
};

// 前往下一筆交易
const goToNext = () => {
  if (!isLastItem.value) {
    state.currentIndex++;
  }
};

const formatToLowerCase = (str) => {
  return str ? str.toLowerCase() : ''; // 如果 str 存在則轉為小寫，否則返回空字串
};

// 格式化日期函數
const formatDate = (date) => {
  // 檢查是否為 Date 對象，若不是則嘗試轉換
  if (!(date instanceof Date)) {
    date = new Date(date);
  }

  // 檢查是否成功轉換為有效的 Date 對象
  if (isNaN(date.getTime())) {
    return "Invalid Date"; // 返回一個預設值或錯誤信息
  }

  const day = date.getDate().toString().padStart(2, '0');
  const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
};



// 修改時間格式為 hh:mm
const formatTime = (datetime) => {
  const date = new Date(datetime);
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');

  return `${hours.toString().padStart(2, '0')}:${minutes}`;
};

// 格式化貨幣函數
const formatCurrency = (value) => {
  const absValue = Math.abs(value);
  return value < 0 ? `-$${absValue}` : `$${absValue}`;
};


// 監聽 initialIndex 的變化，當初始索引改變時更新 currentIndex
watch(
  () => props.initialIndex,
  (newIndex) => {
    state.currentIndex = newIndex;
  }
);
</script>

<style scoped>
.card {
    position: absolute;
    top: 80px;
    left: 0;
    right: 0;
    z-index: 1;
    height: 100%;
    width: 100%; /* 設置寬度為 100% */
    overflow-y: auto;
    overflow-x: hidden; /* 防止左右滑動 */
    border-radius: 10px 10px 0px 0px;
}

.transaction-title{
    width: auto;
    height: 30px;

    /* Portal/Portal – H4 bold */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 30px;

    /* 1E1E2D */
    color: #1E1E2D;
}

.arrow-icon{
  width: 12px;
  height: 20px;
}

.close-btn {
    width: 22px;
    height: 22px;
}

.col-item{
    margin-top: 20px;
    margin-bottom: 20px;
}

.col-title{
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    display: flex;
    align-items: center;

    /* Navy */
    color: #051C2C;
}

.col-value{
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    display: flex;
    align-items: center;
    text-align: right;

    color: #051C2C;
}

.col-amount{
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 23px;
    display: flex;
    align-items: center;

    color: #051C2C;
}

.col-pay{
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 25px;
    display: flex;
    align-items: center;
    text-align: right;

    /* Navy */
    color: #051C2C;
}

.col-line{
    margin-top: 30px;
    margin-bottom: 30px;
    border: 1px solid #99A6B4;
}

.payment-icon{
    width: auto;
    height: 18px;
}

.text-refund{
    color: #189F95;
}

.text-green{
    color: #00c962;
}

.text-red{
    color: red;
}

.pay-line{
    border: 1px solid #E6E9EC;
}
</style>

